import Full from 'Container/Full'

const Dashboard = () => import('Views/dashboard/Dashboard')
const StoreList = () => import('Views/admin-stores/StoreList')
const dashboardEvents = () => import("Views/dashboard-events/DashboardEvents")
const accountTicketMaster = () => import("Views/ticket-master/accounts/AccountsTicketMaster")
const salesTicketMaster = () => import("Views/ticket-master/sales/SalesList");
const showTicketInfoTicketMaster = () => import("Views/ticket-master/sales/SalesDetails");
const ticketUsers = () => import("Views/ticket-master/users/TicketUsers");
const ticketFaqs = () => import("Views/ticketFaqs/Faqs");
export default {
  path: '/',
  component: Full,
  redirect: '/dashboard',
  children: [{
    path: '/dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      title: 'message.dashboard',
      breadcrumb: null
    }
  },
  {
    path: '/faq',
    component: ticketFaqs,
    meta: {
      requiresAuth: true,
      title: 'message.ticketFaqs',
      breadcrumb: null
    }
  },
  {
    path: '/events',
    component: dashboardEvents,
    meta: {
      requiresAuth: true,
      title: 'message.dashboardEvents',
      breadcrumb: null
    }
  },
  {
    path: '/ticket-accounts',
    component: accountTicketMaster,
    meta: {
      requiresAuth: true,
      title: 'message.accounts',
      breadcrumb: "accounts"
    }
  },
  {
    path: '/ticket-user',
    component: ticketUsers,
    meta: {
      requiresAuth: true,
      title: 'message.clients',
      breadcrumb: "clients"
    }
  },
  {
    path: '/ticket-sales/:filter',
    alias: '/ticket-sales',
    component: salesTicketMaster,
    meta: {
      requiresAuth: true,
      title: 'message.sales',
      breadcrumb: "sales"
    }
  },
  {
    path: '/sales/details/:id',
    component: showTicketInfoTicketMaster,
    meta: {
      requiresAuth: true,
      title: 'message.saleDetails',
      breadcrumb: 'Sale Details'
    }
  },
  {
    path: '/stores',
    component: StoreList,
    meta: {
      requiresAuth: true,
      title: 'message.stores',
      breadcrumb: 'Stores'
    }
  },
  {
    path: '/profile',
    component: () => import('Views/users/UserProfile'),
    meta: {
      requiresAuth: true,
      title: 'message.userProfile',
      breadcrumb: 'userProfile'
    }
  },
  {
    path: '/store',
    component: () => import('Views/store/StoreProfile'),
    meta: {
      requiresAuth: true,
      title: 'message.storeProfile',
      breadcrumb: 'Store'
    }
  },
  {
    path: '/store-telegram',
    component: () => import('Views/store/TelegramStore'),
    meta: {
      requiresAuth: true,
      title: 'message.telegramStore',
      breadcrumb: 'Store'
    }
  },
  {
    path: '/store-web',
    component: () => import('Views/store/WebStore'),
    meta: {
      requiresAuth: true,
      title: 'message.webStore',
      breadcrumb: 'Store'
    }
  },
  {
    path: '/store-details/:id',
    component: () => import('Views/admin-stores/StoreDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.details',
      breadcrumb: 'Store Details'
    }
  },
  {
    path: '/store-schedule',
    component: () => import('Views/store/StoreSchedule'),
    meta: {
      requiresAuth: true,
      title: 'message.storeSchedule',
      breadcrumb: 'Schedule'
    }
  },
  {
    path: '/store-faqs',
    component: () => import('Views/faq/FaqsList'),
    meta: {
      requiresAuth: true,
      title: 'message.faq',
      breadcrumb: 'Frequently Asked Questions List'
    }
  },
  {
    path: '/catalogues',
    component: () => import('Views/catalogues/CatalogueList'),
    meta: {
      requiresAuth: true,
      title: 'message.catalogue',
      breadcrumb: 'Catalogue List'
    }
  },
  {
    path: '/products',
    component: () => import('Views/products/ProductList'),
    meta: {
      requiresAuth: true,
      title: 'message.products',
      breadcrumb: 'Product List'
    }
  },
  {
    path: '/products-extra',
    component: () => import('Views/extras/ExtraList'),
    meta: {
      requiresAuth: true,
      title: 'message.extras',
      breadcrumb: 'Extra List'
    }
  },
  {
    path: '/customers',
    component: () => import('Views/telegramUsers/telegramUserList'),
    meta: {
      requiresAuth: true,
      title: 'message.myCustomers',
      breadcrumb: 'My Customers'
    }
  },
  {
    path: '/license-sales',
    component: () => import('Views/license/LicenseSalesList'),
    meta: {
      requiresAuth: true,
      title: 'message.sales',
      breadcrumb: 'License sales'
    }
  },
  {
    path: '/license-sales/:id',
    component: () => import('Views/license/LicenseSalesDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.saleDetails',
      breadcrumb: 'License sales'
    }
  },
  {
    path: '/shopping-list',
    component: () => import('Views/shopping/ShoppingList'),
    meta: {
      requiresAuth: true,
      title: 'message.sales',
      breadcrumb: 'Sales'
    },
  },
  {
    path: '/shopping-details/:id',
    component: () => import('Views/shopping/ShoppingDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.saleDetails',
      breadcrumb: 'Sale Details'
    }
  },
  {
    path: '/delivery-shopping-list',
    component: () => import('Views/shopping/delivery/ShoppingList'),
    meta: {
      requiresAuth: true,
      title: 'message.notVerifiedShippings',
      breadcrumb: 'Shipping List'
    },
  },
  {
    path: '/delivery-shopping-details/:id',
    component: () => import('Views/shopping/delivery/ShoppingDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.shippingDetails',
      breadcrumb: 'Shopping Details'
    }
  },
  {
    path: '/bank-list',
    component: () => import('Views/banks/BankList'),
    meta: {
      requiresAuth: true,
      title: 'message.paymentMethods',
      breadcrumb: 'Payment methods'
    }
  },
  {
    path: '/delivery-bank-list',
    component: () => import('Views/banks/BankList'),
    meta: {
      requiresAuth: true,
      title: 'message.paymentMethods',
      breadcrumb: 'Delivery Banks list'
    }
  },
  {
    path: '/cashiers',
    component: () => import('Views/cashiers/CashiersList'),
    meta: {
      requiresAuth: true,
      title: 'message.cashiers',
      breadcrumb: 'Cashiers List'
    }
  },
  {
    path: '/dealers',
    component: () => import('Views/delivery/admin/DealersList'),
    meta: {
      requiresAuth: true,
      title: 'message.dealers',
      breadcrumb: 'Dealers List'
    }
  },
  {
    name: 'dealer-details',
    path: '/dealer-details/:id',
    component: () => import('Views/delivery/admin/DealerDetails'),
    props: true,
    meta: {
      requiresAuth: true,
      title: 'message.dealer',
      breadcrumb: 'Dealer Details'
    },
  },
  {
    path: '/shippings',
    component: () => import('Views/delivery/admin/ShippingsList'),
    meta: {
      requiresAuth: true,
      title: 'message.shippings',
      breadcrumb: 'Shippings List'
    }
  },
  {
    path: '/shipping-routes',
    component: () => import('Views/delivery/admin/ShippingRates'),
    meta: {
      requiresAuth: true,
      title: 'message.routes',
      breadcrumb: 'Routes'
    }
  },
  {
    path: '/linked-delivery-companies',
    component: () => import('Views/delivery/admin/DeliveryCompaniesList'),
    meta: {
      requiresAuth: true,
      title: 'message.deliveryCompanies',
      breadcrumb: 'Delivery Companies'
    }
  },
  {
    path: '/delivery-profile',
    component: () => import('Views/delivery/delivery/DeliveryProfile'),
    meta: {
      requiresAuth: true,
      title: 'message.deliveryProfile',
      breadcrumb: 'Delivery'
    }
  },
  {
    path: '/delivery-dealers',
    component: () => import('Views/delivery/delivery/DealersList'),
    meta: {
      requiresAuth: true,
      title: 'message.dealers',
      breadcrumb: 'Dealers List'
    }
  },
  {
    path: '/delivery-shippings',
    component: () => import('Views/delivery/delivery/ShippingsList'),
    meta: {
      requiresAuth: true,
      title: 'message.verifiedShippings',
      breadcrumb: 'Shippings List'
    }
  },
  {
    path: '/delivery-shipping-details/:id',
    component: () => import('Views/delivery/delivery/ShippingDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.shippingDetails',
      breadcrumb: 'Shippings Details'
    }
  },
  {
    path: '/delivery-shipping-routes',
    component: () => import('Views/delivery/delivery/ShippingRates'),
    meta: {
      requiresAuth: true,
      title: 'message.routes',
      breadcrumb: 'Routes'
    }
  },
  {
    path: '/delivery-linked-stores',
    component: () => import('Views/delivery/delivery/LinkedStores'),
    meta: {
      requiresAuth: true,
      title: 'message.linkedStores',
      breadcrumb: 'Linked Stores'
    }
  },
  {
    name: 'delivery-dealer-details',
    path: '/delivery-dealer-details/:id',
    component: () => import('Views/delivery/delivery/DealerDetails'),
    props: true,
    meta: {
      requiresAuth: true,
      title: 'message.dealers',
      breadcrumb: 'Dealers List'
    }
  },
  {
    path: '/reports',
    component: () => import('Views/reports/admin/ReportList'),
    meta: {
      requiresAuth: true,
      title: 'message.reports',
      breadcrumb: 'Reports'
    }
  },
  // {
  //   name: 'plans',
  //   path: '/plans',
  //   component: () => import('Views/plans/PlanList'),
  //   meta: {
  //     requiresAuth: true,
  //     title: 'message.plans',
  //     breadcrumb: 'Plan List'
  //   }
  // },
  {
    path: '/delivery-reports',
    component: () => import('Views/reports/delivery/ReportList'),
    meta: {
      requiresAuth: true,
      title: 'message.reports',
      breadcrumb: 'Reports'
    }
  },
  {
    path: '/delivery-companies',
    component: () => import('Views/admin-delivery-companies/DeliveryCompanies'),
    meta: {
      requiresAuth: true,
      title: 'message.deliveryCompanies',
      breadcrumb: 'Delivery Companies'
    }
  },
  {
    path: '/delivery-company-details/:id',
    component: () => import('Views/admin-delivery-companies/DeliveryCompanyDetails'),
    meta: {
      requiresAuth: true,
      title: 'message.details',
      breadcrumb: 'Delivery Companies'
    }
  },
  ]
}